import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const routesServiceApi = createApi({
  reducerPath: 'routesServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetRoutes: builder.query<any, any>({
      query: ({language = CURRENT_LANGUAGE, type= 1}) => `web/menu?menuType=${type}&locale=${language}`,
    }),
  }),
});

export const {
  useLazyGetRoutesQuery,
} = routesServiceApi;
